import { OrderApcTrackingResponseType } from "@sellar-io/api-v2/types";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../components/modal/Dialog";
import { useOrderApcTracking } from "../../../hooks/api/v2/order/useOrderApcTracking";
import { SpinnerLegacy } from "../../spinner";

const apcImageUrl =
  "https://sellar.imgix.net/sellar-image-assets/app-assets/apc-logo.png";

export const ApcTrackingDialog = ({
  active,
  setActive,
  orderId,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  orderId: number;
}) => {
  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="APC tracking information"
      />
      {active && <Content orderId={orderId} />}
    </Dialog>
  );
};

const Content = ({ orderId }: { orderId: number }) => {
  const { data: apcTracking, isFetched } = useOrderApcTracking(orderId);

  const trackingData = apcTracking?.Activity ?? [];

  return (
    <DialogContent className="flex min-h-[200px] w-full flex-col gap-2 px-8 pb-8">
      {!isFetched && <SpinnerLegacy />}
      {trackingData.map((activity, index) => (
        <ActivityStep
          key={index}
          activity={activity}
          last={index === trackingData.length - 1}
        />
      ))}
      {trackingData.length === 0 && isFetched && (
        <div className="w-full py-12">
          <p className="w-full text-center">
            No tracking information available at the moment.
          </p>
        </div>
      )}
    </DialogContent>
  );
};

const ActivityStep = ({
  activity,
  last,
}: {
  activity: OrderApcTrackingResponseType["Activity"][number];
  last: boolean;
}) => {
  return (
    <div className={"flex min-h-[50px] gap-4"}>
      <div className={"flex flex-col items-center gap-2"}>
        <img alt={"apc"} src={apcImageUrl} className={"h-6 w-6"} />
        {!last && (
          <div className="flex h-full w-[2px] items-center bg-zinc-300" />
        )}
      </div>
      <div className={"flex w-full flex-col gap-8"}>
        <div className={"flex flex-col gap-4"}>
          <div className="flex flex-row justify-between">
            <p>
              {activity.Status.StatusDescription}
              {" • "}
              {activity.Status.DateTime.split(" ").join(" - ")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
